// src/app/services/[service]/components/api/ApiAAS.jsx
"use client";

import React from "react";
import Image from "next/image";
import styles from "./ApiAAS.module.css";
import {
  apiAasLeftFeatures as staticLeft,
  apiAasRightFeatures as staticRight,
} from "../../data/api-development";

export default function ApiAAS({ dynamicData }) {
  const tag = dynamicData?.tag || "API DEVELOPMENT";
  const title = dynamicData?.title || "API‑as‑a‑Service (APIaaS) Solutions";
  const subtitle = dynamicData?.subtitle || "Leverage industry protocols and modern API practices. We build secure, efficient web APIs that integrate smoothly with your existing systems and platforms.";
  
  let centerImage = dynamicData?.centerImage || "/assets/img/apidev/api-service1.webp";
  if (centerImage && typeof centerImage === 'string' && (centerImage.includes('\\') || centerImage.includes('uploads'))) {
    const baseUrl = (process.env.NEXT_PUBLIC_API_URL || '').replace(/\/api\/?$/, '').replace(/\/$/, '') || '';
    const cleanPath = centerImage.replace(/\\/g, '/').replace(/.*\/uploads\//, 'uploads/');
    centerImage = `${baseUrl}/${cleanPath}`;
  }

  const leftItems = dynamicData?.leftItems || staticLeft;
  const rightItems = dynamicData?.rightItems || staticRight;

  return (
    <section className={`${styles.section} py-5`}>
      <div className="container">
        <div className={styles.head} data-reveal="fade">
          <div className={styles.eyebrow}>{tag}</div>
          <h2 className={styles.title}>{title}</h2>
          <p className={styles.subtitle}>{subtitle}</p>
        </div>

        <div className={styles.grid}>
          {/* Left features */}
          <div className={styles.list} data-reveal="stagger-up">
            {leftItems.map((f, i) => (
              <div key={i} className={styles.feature}>
                <span className={styles.icon} aria-hidden>
                  <i className={f.icon}></i>
                </span>
                <div>
                  <h3 className={styles.ftitle}>{f.title}</h3>
                  <p className={styles.fdesc}>{f.description || f.desc}</p>
                </div>
              </div>
            ))}
          </div>

          {/* Center images */}
          <div className={styles.images} data-reveal="zoom-in">
            <div className={styles.imgWrap}>
              <Image
                src={centerImage}
                alt={title}
                fill
                className={styles.img}
                unoptimized={true}
              />
            </div>
          </div>

          {/* Right features */}
          <div className={styles.list} data-reveal="stagger-up">
            {rightItems.map((f, i) => (
              <div key={i} className={styles.feature}>
                <span className={styles.icon} aria-hidden>
                  <i className={f.icon}></i>
                </span>
                <div>
                  <h3 className={styles.ftitle}>{f.title}</h3>
                  <p className={styles.fdesc}>{f.description || f.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
